import React from 'react'
import { Container, Typography, Box } from '@mui/material'
import logo from '../../assets/img/41Fipe_logo.png'// Certifique-se de ajustar o caminho da sua logo

const Finish = () => {
  return (
    <Container maxWidth="sm" style={{ height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
      <Box>
        <img src={logo} alt="Logo" style={{ maxWidth: '100%', width: '400px' }} />
      </Box>
      <Typography variant="h2" style={{ marginTop: '20px', textAlign: 'center' }}>
        Inscrições Encerradas
      </Typography>
    </Container>
  )
}

export default Finish
